const ServicesHero = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          alt="Services Background" 
          className="w-full h-full object-cover object-top" 
          src="https://public.readdy.ai/ai/img_res/2b976d60352deaa7b7d43e411dcee11b.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-indigo-950/85 via-purple-950/80 to-slate-900/85"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 w-full text-center">
        <div className="inline-block px-4 py-2 bg-violet-500/20 border border-violet-400/50 text-violet-300 text-sm font-semibold rounded-full mb-6">
          Our Services
        </div>
        <h1 className="text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
          Smart IT Services<br />
          <span className="italic font-light text-violet-400">Built for Growing Businesses</span>
        </h1>
        <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
          Affordable, scalable IT solutions designed to help your business thrive in the digital age.
        </p>
      </div>
    </section>
  );
};

export default ServicesHero;